<template>
  <div id="app">
    <router-view/>
    <van-tabbar v-model="active" route>
      <van-tabbar-item icon="shop-o" to="/">停车场</van-tabbar-item>
      <van-tabbar-item icon="logistics" to="/vehicle">车辆</van-tabbar-item>
      <van-tabbar-item icon="balance-list-o" to="/payment">收费</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  background: #f7f8fa;
}
#app {
  padding-bottom: 50px;
}
</style>
